import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';
import anime from 'animejs/lib/anime.es.js';
import { BaseCardComponent } from "../../../ui-kit/cards/base-card/base-card.component";
import { Router } from '@angular/router';
import { PrimaryBtnComponent } from "app/components/ui-kit/buttons/primary-btn/primary-btn.component";

@Component({
  selector: 'app-icon-prompt-card',
  standalone: true,
  imports: [CommonModule, SvgLoaderComponent, BaseCardComponent, PrimaryBtnComponent],
  templateUrl: './icon-prompt-card.component.html',
  styleUrl: './icon-prompt-card.component.scss'
})
export class IconPromptCardComponent {
  @ViewChild('iconRef', { static: false }) iconRef!: ElementRef;
  @ViewChild('iconCircleRef', { static: false }) iconCircleRef!: ElementRef;
  @Input() iconURL: string = null;
  @Input() label: string = 'Setup Missing';
  @Input() header: string = 'Setup Missing';
  @Input() desc: string = 'Setup Missing';
  @Input() iconColor: string = 'var(--primary-color)'
  @Input() btnText: string = null;
  @Input() btnRoute: string = null;
  @Output() handleBtnClick = new EventEmitter

  constructor(private router: Router) { }

  ngAfterViewInit(): void {

    const el = this.iconRef.nativeElement;
    const outerEl = this.iconCircleRef.nativeElement;

    anime.set(outerEl, {
      opacity: 0,
    });

    anime.set(el, {
      opacity: 0,
    });

    anime({
      targets: outerEl,
      translateY: [10, 0],
      scale: [1.4, 1],
      opacity: [0, 1],
      duration: 800,
      easing: 'spring(1, 80, 10, 0)'
    })

    anime({
      targets: ['.label', '.header', '.desc'],
      translateY: [10, 0],
      opacity: [0, 1],
      duration: 750,
      delay: 300,
      easing: 'spring(1, 80, 10, 0)'
    })

    anime({
      targets: el,
      translateY: [-10, 0],
      opacity: [0, 1],
      duration: 750,
      delay: 1000,
    })

  }

  onClickBtn() {
    if (this.btnRoute) {
      this.router.navigate([this.btnRoute]);
    } else {
      this.handleBtnClick.emit();
    }
  }

}
